<template>
  <div class="max-w-screen-xl mt-10 relative z-10 mx-auto px-4">
    <div class="flex items-center justify-between w-full lg:flex-row flex-col">
      <div class="flex flex-col items-start gap-4 w-full">
        <h3 class="text-white font-semibold">
          {{ data?.heading }}
        </h3>
        <p
          class="text-white md:text-lg leading-[1.7]"
          v-for="text in data?.text"
        >
          {{ text }}
        </p>
      </div>
      <div class="w-full">
        <NuxtImg
          src="/images/service-right.webp"
          height="684"
          width="565"
          loading="lazy"
          priority
          :alt="data?.heading"
          format="webp"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: {
    heading: string;
    text: string[];
  };
}>();
</script>
